export default {
	title: "Étapes du parcours",
	name: "Nom",
	description: "Description",
	createStage: "Créer une étape du parcours",
	createSuccess: "Étape du parcours créée avec succès !",
	updateSuccess: "Étape du parcours mise à jour avec succès !",
	deleteSuccess: "Étape du parcours supprimée avec succès !",
	deleteError: "Erreur lors de la suppression de l'étape du parcours",
	category: {
		label: "Catégorie",
		MEDIUNICA: "Médiumnité",
		RITUALISTICA: "Rituelle",
		FORMACAO: "Formation",
	},
	requiredStage: "Prérequis",
	requiredStageHint: "Étape que la personne doit avoir accomplie au préalable",
	associatedPeople: "Médiums en : {name}",
	confirmDeleteAssignment: "Êtes-vous sûr de vouloir dissocier {person} du parcours \"{stage}\" ?",
	confirmDeleteMessage: "Êtes-vous sûr de vouloir supprimer le parcours \"{name}\" ? Cette action est irréversible.",
	confirmDeleteWithPeopleMessage: "Le parcours \"{name}\" a encore des médiums associés. Voulez-vous le supprimer quand même ? Les associations seront également supprimées.",
	empty: {
		description: "Enregistrez les étapes de développement spirituel de votre temple",
		title: "Aucun parcours médiumnique trouvé",
	},
	hasAssociatedPeopleDetailed: "Il y a {active} association(s) active(s) et {inactive} association(s) inactive(s) dans ce parcours. Dissociez-les avant de supprimer.",
	noAssociatedPeople: "Aucun médium associé à ce parcours",
	order: "Ordre",
	stats: {
		avgPerStage: "Moy./Étape",
		totalPeople: "Personnes",
		totalStages: "Étapes",
	},
	viewActiveAssociated: "Voir les actifs",
};
